import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  selectpropertyManagerDetails,
  selectAuthenticatedUser,
} from 'src/store/selectors/auth';
import {
  fetchPropertyDetailsByProperty,
} from 'src/store/actions/auth';
import {
  fetchUserSuites,
} from 'src/store/actions/userSuites';
import {
  selectCurrentUserSuite,
  selectUserSuiteList,
} from 'src/store/selectors/userSuites';
import HomeOwnerOnboardingDashboard from '../../components/HomeOwnerDashboard/HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard';
import {
  onFetchOnboardingOrders,
} from 'src/store/actions/HomeOwnerOnboardingDashboard';
import Loader from '../../components/Loader';
import { fetchtAllowedTabList } from 'src/store/actions/tabSelections';
import { store } from 'src/store';

const HomeOwnerDashboardvsOnboardingDashboard = (props: any) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector(selectAuthenticatedUser) as any;
  const propertyManagerDetails = useSelector(selectpropertyManagerDetails) as any;
  const currentUserSuite = useSelector(selectCurrentUserSuite) as any;
  const userSuiteList = useSelector(selectUserSuiteList) as any;
  const onboardingData = useSelector((state: any) => state.onboardingData) as any;

  const prevCurrentUserSuiteRef = useRef<any>(currentUserSuite);

  useEffect(() => {
    const loader = (props as any).loader;

    let currentpropertyId =
      userSuiteList && userSuiteList.length > 0 && userSuiteList[0].propertyId
        ? userSuiteList[0].propertyId
        : currentUserSuite.propertyId;
    dispatch(fetchUserSuites(user.id, loader, user.roles[0].role.name) as any);
    dispatch(fetchPropertyDetailsByProperty(currentpropertyId) as any);
    dispatch(fetchtAllowedTabList(currentpropertyId) as any);

    setTimeout(() => {
      const { orders } = store.getState().onboardingData;
      const showHomeownerDasboard =
        Object.keys(orders).length > 0 ? true : false;

      if (showHomeownerDasboard === false && user.isDashboardAccess === false) {
        if (
          currentUserSuite.propertyId !== undefined &&
          currentUserSuite.id !== undefined
        ) {
          let link = `/app/suites/${currentUserSuite.propertyId}&${currentUserSuite.id}`;
          history.push({
            pathname: link,
            state: {
              suite: { id: currentUserSuite.id },
              property: {
                id: currentUserSuite.propertyId,
              },
              activeTab: 0,
              from: 'Dashboard',
            },
          });
        }
      }
    }, 3000);
  }, []);

  useEffect(() => {
    const prevCurrentUserSuite = prevCurrentUserSuiteRef.current;

    if (prevCurrentUserSuite.id !== currentUserSuite.id) {
      dispatch(fetchPropertyDetailsByProperty(currentUserSuite.propertyId) as any);
      dispatch(fetchtAllowedTabList(currentUserSuite.propertyId) as any);
      dispatch(
        onFetchOnboardingOrders(
          currentUserSuite.propertyId,
          currentUserSuite.id,
          user.id
        ) as any
      );

      setTimeout(() => {
        const { orders } = store.getState().onboardingData;
        const showHomeownerDasboard =
          Object.keys(orders).length > 0 ? true : false;

        if (
          showHomeownerDasboard === false &&
          user.isDashboardAccess === false
        ) {
          if (
            currentUserSuite.propertyId !== undefined &&
            currentUserSuite.id !== undefined
          ) {
            let link = `/app/suites/${currentUserSuite.propertyId}&${currentUserSuite.id}`;
            history.push({
              pathname: link,
              state: {
                suite: { id: currentUserSuite.id },
                property: {
                  id: currentUserSuite.propertyId,
                },
                activeTab: 0,
                from: 'Dashboard',
              },
            });
          }
        }
      }, 3000);
    }
    prevCurrentUserSuiteRef.current = currentUserSuite;
  }, [currentUserSuite.id]);

  const { orders } = store.getState().onboardingData;

  const showHomeownerDasboard: boolean = Object.keys(orders).length > 0;

  return !showHomeownerDasboard && user.isDashboardAccess === false ? (
    <Loader center={true} />
  ) : (
    <div className="homeDasboard">
      {propertyManagerDetails && propertyManagerDetails.propertyName ? (
        <>
          <>
            {((onboardingData &&
                onboardingData.fetchOrdersLoading === true) ||
              (onboardingData &&
                onboardingData.fetchDetailsLoading === true)) && (
              <Loader center={true} />
            )}

            {showHomeownerDasboard || user.isDashboardAccess === true ? (
              <HomeOwnerOnboardingDashboard
                currentUserSuite={currentUserSuite}
              />
            ) : (
              <Loader center={true} />
            )}
          </>
        </>
      ) : null}
    </div>
  );
};

export default HomeOwnerDashboardvsOnboardingDashboard;